import React from "react";
import Typography from "@material-ui/core/Typography";

const SubtitleLabelView = ({...props}) => {
    return (
        <tr>
            <td valign={"middle"} align='left'>
                <i className={"material-icons"}>{props.icon ?? ""}</i>
            </td>
            <td valign={"middle"} align='left'>
                <Typography variant="subtitle2" gutterBottom className={"secondary-text"}
                            align={props.align ? props.align : "left"}
                            style={{fontWeight: props.isBold ? "bolder" : '', padding:'0px'}}
                            hidden={props.hidden ? props.hidden : false}>
                    {props.header}
                </Typography>
            </td>
        </tr>



    )
};

export default SubtitleLabelView;